import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';

import { Environment } from '../classes/environment';

interface CheckoutSessionResponse {
  sessionId?: string;
}

export interface StripePriceDto {
  id: string;
  currency: string;
  unitAmount: number;
  recurringInterval?: 'day' | 'week' | 'month' | 'year';
  recurringIntervalCount?: number;
  product?: string;
  productId?: string;
  productName?: string;
  nickname?: string;
}

export interface PaymentStatusDto {
  planId?: string;
  status?: string;
  active?: boolean;
  subscriptionId?: string;
  nextPaymentDate?: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(
    @Inject('environment') private environment: Environment,
    private httpClient: HttpClient
  ) {}

  createCheckoutSession(
    priceId: string,
    quantity: number,
    successUrl: string,
    cancelUrl: string
  ): Observable<string> {
    const payload = {
      priceId,
      quantity,
      successUrl,
      cancelUrl,
    };

    return this.httpClient
      .post<CheckoutSessionResponse>(
        `${this.environment.backendUrl}payments/create-checkout-session`,
        payload
      )
      .pipe(
        map((response) => {
          if (!response?.sessionId) {
            throw new Error('Die Stripe Session ID fehlt in der Serverantwort.');
          }
          return response.sessionId;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  getStripePrices(): Observable<StripePriceDto[]> {
    return this.httpClient.get<StripePriceDto[]>(
      `${this.environment.backendUrl}payments/prices`
    );
  }

  getPaymentStatus(): Observable<PaymentStatusDto> {
    return this.httpClient.get<PaymentStatusDto>(
      `${this.environment.backendUrl}payments/status`
    );
  }
}
